import Cropper from "react-cropper";
import styled from "styled-components";

export const Container = styled.div``;

export const Crop = styled(Cropper)`
  width: 100%;
`;
